const PlatformIcon = () => {
    return (
        <svg
            id="Group_7955"
            data-name="Group 7955"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 17 20"
        >
            <g id="Group_7954" data-name="Group 7954">
                <path
                    id="Path_3389"
                    data-name="Path 3389"
                    d="M.375,4.653V.375h16V4.653m-16,0V19.2l8-5.989,8,5.989V4.653m-16,0h16"
                    transform="translate(0.125 0.213)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.75"
                />
            </g>
        </svg>
    );
};

export default PlatformIcon;
